import { compact, concat, includes } from 'lodash/fp';

import constants from '../../ahm-constants';
import getAppleBusinessChatData from '../../utils/get-apple-business-chat-data';
import liveChatConfig from '../../utils/livechat';

const healthInsuranceMenuItems = {
  linkTo: constants.URLS.SALES.REFINE_PRICE,
  subItems: [
    { linkTo: constants.URLS.SALES.CHOOSE_YOUR_COVER_ABOUT, text: 'Choose your own hospital & extras' },
    { linkTo: constants.URLS.SALES.PRODUCT_LISTING_HOSPITAL, text: 'Compare hospital' },
    { linkTo: constants.URLS.SALES.PRODUCT_LISTING_EXTRAS, text: 'Compare extras' },
    { linkTo: constants.URLS.SALES.OFFER_HOME, text: 'Latest offers' },
  ],
};

const featuresMenuItems = {
  linkTo: constants.URLS.SALES.HEALTH_INSURANCE,
  subItems: [
    { linkTo: constants.URLS.SALES.HEALTH_INSURANCE_EXTRAS_COVER, text: 'Learn about extras cover' },
    { linkTo: constants.URLS.SALES.HEALTH_INSURANCE_HOSPITAL_COVER, text: 'Learn about hospital cover' },
    { linkTo: constants.URLS.SALES.YOUTH_DISCOUNT, text: 'Youth discount' },
    { linkTo: constants.URLS.SALES.NO_GAP_DENTAL, text: 'No gap dental' },
    { linkTo: constants.URLS.SALES.TAX, text: 'Tax & hospital cover' },
    { linkTo: constants.URLS.SALES.PREGNANCY, text: 'Pregnancy' },
    { linkTo: constants.URLS.SALES.EXPLAINED_HEALTH_INSURANCE_EXPLAINED, text: 'Health insurance explained' },
    { icon: 'external-link-light', linkTo: constants.URLS.OSHC.HOME, text: 'Overseas students' },
  ],
};

const perksMenuItems = {
  id: 'perks',
  linkTo: constants.URLS.SALES.OFFERS_HOME,
  subItems: [
    {
      icon: 'chevron-right-light',
      linkTo: constants.URLS.SALES.OFFERS_HOME,
      text: 'See all perks',
    },
  ],
  variants: ['tabInline'],
};

const rightSideMenuItems = [
  {
    linkTo: constants.URLS.HELP.HOME,
    position: 'right',
    text: 'help',
  },
  {
    linkTo: constants.URLS.SALES.CONTACT_US,
    position: 'right',
    text: 'contact us',
  },
  {
    linkTo: `tel:${constants.CONTACT.PHONE.STANDARD}`,
    mobileOnly: true,
    position: 'right',
    text: 'call us now',
  },
];

const generateMenuItems = () =>
  compact(
    concat(
      [
        {
          linkTo: constants.URLS.SALES.PRODUCT_LISTING,
          subItemGroups: [
            {
              ...healthInsuranceMenuItems,
              groupText: 'Find cover',
            },
            {
              ...featuresMenuItems,
              groupText: 'Health insurance',
            },
            {
              ...perksMenuItems,
              groupText: 'Perks',
            },
          ],
          text: 'health',
        },
        {
          linkTo: constants.URLS.SALES.TRAVEL_INSURANCE,
          text: 'travel',
        },
        {
          linkTo: constants.URLS.SALES.CAR_INSURANCE,
          text: 'car',
        },
        {
          linkTo: constants.URLS.SALES.HOME_INSURANCE,
          text: 'home',
        },
        {
          linkTo: constants.URLS.SALES.LIFE_INSURANCE,
          text: 'life',
        },
        {
          linkTo: constants.URLS.SALES.INCOME_INSURANCE,
          text: 'income',
        },
        {
          linkTo: constants.URLS.SALES.PET_INSURANCE,
          text: 'pet',
        },
      ],
      rightSideMenuItems,
    ),
  );

const getMenuItems = (
  actionsLiveChat: {
    launch: (liveChatConfig: {}) => void;
  },
  isAbcSupportedAndAvailable: boolean,
  liveChatStatus: number,
  location?: {
    pathname?: string;
  },
) => {
  if (includes(location?.pathname, constants.LIVEPERSON.LIVECHAT_URL_BLOCKLIST)) {
    return generateMenuItems();
  }

  const launchLiveChatWindow = () => {
    actionsLiveChat.launch(liveChatConfig);
  };

  const livechatMenuItem = {
    appleBusinessChat: getAppleBusinessChatData({ isAbcSupportedAndAvailable }),
    launchChatWindow: launchLiveChatWindow,
    mobileOnly: true,
    position: 'right',
    status: liveChatStatus,
    text: 'message us',
    variants: ['contextLiveChat'],
  };

  return [...generateMenuItems(), livechatMenuItem];
};

export default getMenuItems;
